<template>
  <div>
    <div class="advertiseList">
      <div
        v-for="(item, index) in advertiseMentLIst"
        :key="index"
        @click="goDatails(item.banner.url)"
      >
        <img :src="item.banner.thumb_url" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { getData, postData } from "../Interface/http.js";
export default {
  data() {
    return {
      advertiseMentLIst: [],
    };
  },
  methods: {
    //获取首页4个格子信息
    getFourBoxInfo() {
      let me = this;
      getData("/recommend-lists?position=11")
        .then((res) => {
          me.advertiseMentLIst = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goDatails(url) {
      if (!url) {
        return;
      }
      if (!url.includes("jfbst.com")) {
        Dialog.confirm({
          message:
            "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服",
        }).then(() => {
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    },
  },
  mounted() {
    this.getFourBoxInfo();
  },
};
</script>
<style scoped>
.advertiseList {
  margin: 8px auto;
  width: 95%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.advertiseList > div {
  width: calc((100% - 6px) / 4);
  height: 40px;
  margin-top: 2px;
}
</style>
